import { Tooltip } from "./style"

const ToolTip = ({children}) => {

  return (
    <Tooltip>
    {children}
  </Tooltip>  
  )
}
export default ToolTip
